import React, { useEffect } from 'react'
import { logSessionInfo } from '../../../../../services/logger'
import './TeacherRetryView.scss'

export default function TeacherRetryView(props) {
  const { goToASRTest } = props;

  useEffect(() => {
    logSessionInfo('teacherTroubleshoot_TEACHER_RETRY_SCREEN', {});
  }, []);

  const handleRetryTest = () => {
    logSessionInfo('teacherTroubleshoot_RETRY_STUDENT_TEST', {});
    goToASRTest();
  }

  return (
    <div className="teacher-retry-view">
      <div className="teacher-retry-view__content">
        <div className="teacher-retry-view__message">
          I still can't hear you. Here are some suggestions:
        </div>
        
        <div className="teacher-retry-view__suggestions">
          <div className="teacher-retry-view__suggestion-item">
            • Try switching to your device's internal microphone.
          </div>
          <div className="teacher-retry-view__suggestion-item">
            • Try switching to a different headset or microphone.
          </div>
          <div className="teacher-retry-view__suggestion-item">
            • Try switching to a different computer, device, etc.
          </div>
        </div>
      </div>
      
      <div className="teacher-retry-view__button-container">
        <button 
          className="teacher-retry-view__button"
          onClick={handleRetryTest}
        >
          Retest Mic
        </button>
      </div>
    </div>
  );
}

